import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '@src/hooks/useBreakpoints';
import { ComponentSwitcher } from '../ComponentSwitcher';
import Selections from './steps/Selections';
import Options from './steps/Options';
import Cover from './steps/Cover';
import * as styles from './maker.module.css';
import { useIsWorksheetOpen, useQuestions, worksheetActions } from '@src/stores/worksheet.store';

const components = {
  questions: Selections,
  toggles: Options,
  cover: Cover,
};

export const steps = Object.keys(components).map((step, index) => ({
  step,
  number: index + 1,
}));

const WorkSheetMaker = () => {
  const open = useIsWorksheetOpen();
  const isMobile = useIsMobile();
  const questionCount = useQuestions()?.length;

  useEffect(() => {
    if (isMobile) {
      worksheetActions.setOpen(false);
    }
  }, [isMobile]);

  return (
    <div className={styles.maker}>
      <div className={styles.header}>
        <p style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          Worksheet Maker{' '}
          {questionCount > 0 && <span className={styles.questionCount}>{questionCount}</span>}
        </p>
        <button onClick={worksheetActions.toggleOpen}>
          <span>{open ? 'Close' : 'open'}</span>
          {open ? '-' : '+'}
        </button>
      </div>
      <motion.div
        className={styles.content}
        initial={{ height: 0 }}
        animate={{ height: open ? 'auto' : 0 }}
        transition={{ duration: 0.2 }}
      >
        <ComponentSwitcher components={components} show="questions" />
      </motion.div>
    </div>
  );
};

export default WorkSheetMaker;
